import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import SearchBar, { ISearchBarProps, ISearchBarState } from 'src/components/SearchBar';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import { ActivityThemeSelector } from 'src/Entities/ActivityTheme/ActivityTheme.Selector';
import { stringifyQuery } from './Search.utils';

interface ISearchComponentProps extends RouteComponentProps, ISearchBarProps {
  themes: IActivityThemeModel[];
  onSearch?: (query: ISearchBarState) => any;
}

const SearchComponent = (props: ISearchComponentProps) => {
  const handleSearch = React.useCallback(
    (query: ISearchBarState) => props.history.push(`/search?${stringifyQuery(query)}`),
    []
  );

  return (
    <SearchBar
      themes={props.themes}
      className={props.className}
      initialState={props.initialState}
      style={props.style}
      onSearch={handleSearch}
    />
  );
};

const mapStateToProps = () => ({
  themes: ActivityThemeSelector.getThemes()
});

export default withRouter(connect(mapStateToProps)(SearchComponent));



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/SeachPage/Seach.component.tsx